import React, { Component } from 'react';
import { ListItem, ListItemText, ListItemIcon, Collapse } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';

import Aux from '../../../hoc/NoParent';
import NavigationMenu from './NavigationMenu';

const NavigationItemBase = ({ indented, text, icon, secondaryIcon, ...props }) => {
    return <ListItem key={text} button {...props}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={text} />
        {secondaryIcon ? <ListItemIcon>{secondaryIcon}</ListItemIcon> : null}
    </ListItem>
}

class NavigationItemWithChildren extends Component {
    state = {
        open: false
    }

    onClickHandler = (onClick) => {
        if(onClick) {
            onClick();
        }
        this.setState(state => ({ open: !state.open }));
    }

    render() {
        const { component, menuItems, onClick, ...props } = this.props;

        return (
            <Aux>
                <NavigationItemBase {...props} secondaryIcon={this.state.open ? <ExpandLess /> : <ExpandMore />} onClick={() => this.onClickHandler(onClick)} />
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <NavigationMenu component={component} indented menuItems={menuItems} />
                </Collapse>
            </Aux>
        );
    }
}

const NavigationItemStatic = (props) => {
    return <NavigationItemBase {...props} />
}

const NavigationItem = (props) => {
    let renderedItem = null;

    if(props.menuItems) {
        renderedItem = <NavigationItemWithChildren {...props} />;
    }
    else {
        renderedItem = <NavigationItemStatic {...props} />;
    }

    return renderedItem;
}

export default NavigationItem;